import { render, staticRenderFns } from "./TabsItem.vue?vue&type=template&id=15ae8b73&scoped=true&"
import script from "./TabsItem.vue?vue&type=script&lang=js&"
export * from "./TabsItem.vue?vue&type=script&lang=js&"
import style0 from "./TabsItem.vue?vue&type=style&index=0&id=15ae8b73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae8b73",
  null
  
)

export default component.exports